import { memo } from 'react'

interface ErrorMessageProps {
  id?: string
  message?: string
}

export const ErrorMessage = memo(({ id, message }: ErrorMessageProps) => {
  if (!message) {
    return null
  }
  return (
    <p id={id} className="error-text">
      {message}
    </p>
  )
})

ErrorMessage.displayName = 'ErrorMessage'
